import './App.css';
import Banner from './sections/Banner/Banner.jsx';
import Event from './sections/Evento/Event.jsx';
import Format from './sections/Evento/Format.jsx';
import MovingText from './sections/Evento/MovingText.jsx';
import Premi from './sections/Evento/Premi.jsx';
import Schedule from './sections/Evento/Schedule.jsx';
import WideImg from './sections/Evento/WideImg.jsx';
import WideImg2 from './sections/Evento/WideImg2.jsx';
import Footer from './sections/Footer/Footer.jsx';
import Hero from './sections/Hero/Hero.jsx';
import Navbar from "./sections/Navbar/Navbar.jsx"
import Contatti from './sections/Registration/Contatti.jsx';
import RegistrationBanner from './sections/Registration/RegistrationBanner.jsx';
import RegistrationForm from './sections/Registration/RegistrationForm.jsx';

function App() {
  return (
    <main className='max-w-screen overflow-x-hidden'>
      <Navbar/>
      <Hero/>
      <Banner/>
      <Event/>
      <WideImg/>
      <Format/>
      <MovingText/>
      <RegistrationBanner/>
      <Schedule/>
      <WideImg2/>
      <Contatti/>
      <RegistrationForm/>
      <Footer/>
    </main>
  );
}

export default App;
